// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса) — словарь сегмента, обрезанный потолком бэка.
// Бэк отдаёт fetchMode 'all' не больше itemsSource-limit строк (my_database.get_itemsSource, LIMIT 5000, без ORDER). Замер dev02 27.10:
// segment-5 «БиТ_Регионы» — 5541 запись, 'all' вернул 5000 + пустую; «Грузия» (4da17dde…) и «Казахстан» (4da17de0…) за потолком.
// Фронт считал любой ответ 'all' полным: (1) data заменялась целиком — уже разрешённые by_ids тайтлы пропадали; (2) _pending_fetchMode
// оставался 'all' навсегда — каждый следующий by_ids по сегменту превращался в justGet (в сеть не уходил), id оставался GUID'ом
// в списке подбора чипса, в «Нещодавні» и везде по сеансу. Выключатель — fe.ux.dictAllTruncated (по умолчанию вкл).
export const ITEMS_SOURCE_CAP = 5000   // дефолт настройки бэка itemsSource-limit; тот же порог, что у докачки ODOO-2388 (by_ids ≥ 5000 — «обрезан»)

export function itemsSourceAll_isTruncated(data, cap = ITEMS_SOURCE_CAP) {
    return Array.isArray(data) && data.length >= cap
}

// новый список целиком, затем строки прежнего, которых в новом нет (разрешённые раньше by_ids за потолком 'all')
export function itemsSourceAll_keepResolved(oldData, newData) {
    if (!Array.isArray(oldData) || !oldData.length) return newData
    const seen = new Set(newData.map(it => String(it?.id)))
    const out = newData.slice()
    for (const it of oldData) if (it && it.id != null && !seen.has(String(it.id))) out.push(it)
    return out
}

// id запроса by_ids, поглощённого ожиданием 'all' (justGet / слияние очереди), — запомнить: после неполного 'all' их спросят заново
export function itemsSourceAll_remember(itemsSource, ids) {
    if (!itemsSource || !Array.isArray(ids) || !ids.length) return
    if (!itemsSource._ids_waitAll) itemsSource._ids_waitAll = new Set()
    for (const id of ids) if (id != null && id !== '') itemsSource._ids_waitAll.add(id)
}

// после ответа 'all': неполный — словарь не считается полным (by_ids снова ходят), возвращает id, которые надо спросить заново
// (запомненные и не пришедшие; из _pending_ids снимаются, иначе фильтр get_itemsSource их отбросит); полный — список ожидания пуст
export function itemsSourceAll_settle(itemsSource, truncated) {
    const wait = itemsSource?._ids_waitAll
    if (itemsSource) itemsSource._ids_waitAll = null
    if (!truncated || !itemsSource) return []
    if (itemsSource._pending_fetchMode === 'all') itemsSource._pending_fetchMode = null
    itemsSource._all_truncated = true
    const again = wait ? [...wait].filter(id => !itemsSource.ids?.[id]) : []
    for (const id of again) itemsSource._pending_ids?.delete(id)
    return again
}
